<template>
    <q-card id="featureSummaryPane" v-bind="attrs">
        <div v-if="finalData" class="q-pa-sm">
            <div class="text-h7 underline text-uppercase">Hardbottom</div>
            <ul class="q-mt-xs">
                <li> {{  attrText["FEAT_HB"][finalData["FEAT_HB"]]  }}</li>
            </ul>
            <div class="text-h7 underline text-uppercase">Slopes</div>
            <ul  class="q-mt-xs">
                <li>{{  attrText["FEAT_SL"][finalData["FEAT_SL"]] }}</li>
            </ul>
            <div class="text-h7 underline text-uppercase">Sediment</div>
            <ul  class="q-mt-xs">
                <li>{{  attrText["FEAT_SED"][finalData["FEAT_SED"]] }}</li>
            </ul>
            
            <div>
                <div class="text-h7 underline text-uppercase" v-if="finalData['FEAT_SL'] == 2 || [1, 2].includes(finalData['FEAT_HB'])">Connections</div>
                <ul  class="q-mt-xs">
                    <li v-if="finalData['FEAT_SL'] == 2 || [1, 2].includes(finalData['FEAT_HB'])">Several <span class="myLink" @click="goTo({'link' :'../species/fish', 'params' :  {'type' : 'activeSpGroup', 'theme' : 'fish', 'value' : 'demersal'}})">demersal fish species</span> are known to be attracted to features with high slopes and /or hardbottom.</li>
                    <li v-if="finalData['FEAT_SL'] == 2 || [1, 2].includes(finalData['FEAT_HB'])">Hardbottoms and high slopes may be good indicators of potential coral habitats.</li>
                    
                    <!-- Removed coral data from species tab, so remove link to coral data -->
                    <!-- <li v-if="finalData['FEAT_SL'] == 2 || [1, 2].includes(finalData['FEAT_HB'])">Hardbottoms and high slopes may be good indicators of potential <span class="myLink" @click="goTo({'link' :'../species/corals'})">coral habitats</span>.</li> -->
                </ul>
            </div>
            
        </div>
    </q-card>

    <div v-for="(infoObj, name) in infoDialogs" :key="name" >
        <q-dialog v-model="infoObj.model">
            <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
        </q-dialog>
    </div>
</template>
<script setup lang="ts">
import { toRefs, ref, computed, onMounted, useAttrs } from "vue";
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import InfoDialog from "./InfoDialog.vue";
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()
const {  tileLayers, toggleLayer, print, printing, ecos, styleMap, processedData, loadDataByID, activeLayerID, setProcessedData, setActiveSpGroups, setActiveCoastalHabitat } = useMapItems()
const { arrayFindObjectByProp, getMode } = useHelpers();
const attrs = useAttrs();

const props = defineProps({
    data: { type: Object },
    version: {type: Number}
})

const { data, version } = toRefs(props)
const summaryData =  computed(() =>{
    if (data.value && data.value["FEATURES_SUMMARY"] && data.value["FEATURES_SUMMARY"].length >0){
        return data.value["FEATURES_SUMMARY"]
    }
    else{ return null}
})


const finalData = computed(() => {
    if (
        !processedData.value[version.value] || 
        processedData.value[version.value]['FEATURES_SUMMARY'] === undefined ||
        processedData.value[version.value]['FEATURES_SUMMARY']['a'] === undefined ||
        processedData.value[version.value]['FEATURES_SUMMARY']['a']['a'] === undefined
    ){
        if (summaryData.value) {
            const finalData = {}
            const workingData = {}

            Object.keys(attrText).forEach((attr) =>{
                workingData[attr] = []
            })

            /////////// PROCESS CELL DATA
            summaryData.value.forEach((cell) => {
                Object.keys(attrText).forEach((attr) =>{
                    workingData[attr].push(cell[attr])
                })
            })

            const maxAttrs = ["FEAT_HB", "FEAT_SL"]
            const modeAttrs = ["FEAT_SED"]

            maxAttrs.forEach((attr) =>{
                finalData[attr] = Math.max(...workingData[attr])
            })

            modeAttrs.forEach((attr) =>{
                finalData[attr] = getMode(workingData[attr])
            })

            // console.log(finalData)
            
            setProcessedData(version.value, "FEATURES_SUMMARY", 'a', 'a', finalData)
            return finalData
        }
        else{
            return null
        }
    }
    else{
        // console.log("Loading ", processedData.value[version.value]['FEATURES_SUMMARY']['a']['a'])
        return processedData.value[version.value]['FEATURES_SUMMARY']['a']['a']
    }
    
})

const goTo = (obj) =>{
    if(obj.params){
        if (obj.params.type == 'activeSpGroup'){
            setActiveSpGroups(obj.params.theme, obj.params.value)
        }
        if (obj.params.type == 'activeCoastalHab'){
            setActiveCoastalHabitat(obj.params.value)
        }
    }
    if (obj.link){
        // console.log(route.fullPath)
        const path = `${obj.link}`
        router.push(path)
    }
    // console.log(obj)
}

const attrText = {
    "FEAT_HB" : {
        0: "No known or estimated hardbottom is within the area.",
        1: "This area has been estimated to have hardbottom based on the slope of its features.",
        2: "This area includes known hardbottom."
    },
    "FEAT_SL" :{
        "0": "No known slopes steeper than 20% are found within the area.",
        "1": "Area has slope higher than 20%. However, because of low resolution of the data, it is possible that slopes here are higher.",
        "2": "Area includes features with slopes higher than 30%."
    },
    "FEAT_SED" : {
        "-9" : "No Data",
        "0" : "Sediment contains combinations of the three main types of sediments (sand, mud, and gravel",
        "1" : "Majority sediment is sand, although it contains combinations of other sediments.", 
        "2" : "Majority sediment is mud, although it contains combinations of other sediments.",
        "3" : "Majority sediment is gravel, although it contains combinations of other sediments."
    }
}

const infoDialogs = ref({
    wetlands: {
        pName: "Coastal Marshes",
        model: false,
        text: "More info about the importance of coastal marshes."
    }
})

onMounted(() => {
    if (activeLayerID.value != 'FEATURES_SUMMARY'){
        loadDataByID('FEATURES_SUMMARY', version)
    }

})
</script>
<style scoped>
</style>